import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import { css } from '@emotion/react';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useDeleteAllPrepaidCards from './hooks/useDeleteAllPrepaidCards';

const DeleteAllPrepaidCardsModal: ActivityComponentType = () => {
    const { t, i18n } = useTranslation('prepaidCard');
    const { language } = i18n;
    const { pop } = useFlow();
    const { handleDeleteAllPrepaidCards } = useDeleteAllPrepaidCards();
    return (
        <Modal>
            <ModalContainer>
                <Column spacing={36} align='center' fullWidth>
                    <Text align='center' size={language === 'ja' ? 'lg' : 'xl'} css={css`white-space: pre-wrap; 
                        word-break: break-word`}>
                        {t('manage.deleteAllModal.confirm')}
                    </Text>
                    <Column fullWidth spacing={10}>
                        <Button variant='secondary'
                            fullWidth
                            onClick={pop}>
                            {t('manage.delete.cancel')}
                        </Button>
                        <Button fullWidth onClick={handleDeleteAllPrepaidCards}>
                            {t('manage.delete.deleteButton')}
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default DeleteAllPrepaidCardsModal;
